var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "depth-wrapper" },
    [
      _c("div", { staticClass: "bar" }, [
        _c("div", { staticClass: "btn active __pointer" }, [
          _vm._v(_vm._s(_vm.$t("trade.depthView")))
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "btn __pointer", on: { click: _vm.toogleDepth } },
          [_vm._v(_vm._s(_vm.$t("trade.klineView")))]
        )
      ]),
      _vm._v(" "),
      _c("e-charts", {
        staticClass: "e-charts-wrapper",
        attrs: { "auto-resize": "", options: _vm.deptChartOption }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }